import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Padma Purana',
    description: 'Explore the Jain Padma Purana in English and Hindi: an illustrated family tree of the Ikshvaku, Vidyadhara, Rakshasa, Vanara and Hari clans, the story in twelve parts, and all 123 chapters in detail.',
    placeholder: '',
    url: getOrigin(),
    ogImage: '/images/arcs/return.jpg'
}
